import React, { useState, useEffect, useContext } from "react";
import { LuSearch } from "react-icons/lu";
import { TbUser } from "react-icons/tb";
import { IoIosArrowRoundForward } from "react-icons/io";
import { FaStar } from "react-icons/fa6";
import { PiBriefcaseLight } from "react-icons/pi";
import { MdMoreVert } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./JobDetails.scss";
import dummy from "../../assets/images/user.png";
import AddProfile from "./AddProfile";
import CreateBoard from "./CreateBoard";
import ProfileDetails from "./ProfileDetails";
import { AddAssesment } from "../candidateDetails/AddAssesment";
import AssignTo from "./AssignTo";
import { useParams, useNavigate } from "react-router-dom";
import jobApi from "../../services/jobApi";
import masterApi from "../../services/masterApi";
import { FunctionalityNames } from "../../enum/enum";
import { getPermissionRights} from "../../utils/common";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import {useRef} from "react"
import candidateApi from "../../services/candidateApi";
import { getMailBody } from "../../utils/common";
import { EmployeeCandidateForm } from "./EmployeeCandidateForm";
import {AssignContext } from "../../context/AssignContext";


export default function Candidates() {
    const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;
    const { rolePermissions } = useContext(AuthContext);
    const {selectedAssigneeList} = useContext(AssignContext)
    const rejectedBoardLimitDay = process.env.REACT_APP_REJECTED_BOARD_LIMIT_DAY;
    const [boardPerm, setBoardPerm] = useState({});  
    const [mappingPerm, setMappingPerm] = useState({}); 
    const navigate = useNavigate();    
    const [candidateListPerm, setCandidateListPerm] = useState({});

    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const [isCreateBoardVisible, setIsCreateBoardVisible] = useState(false);
    const [tasks, setTasks] = useState(null);
    const [isCardMoreVisible, setIsCardMoreVisible] = useState(false);
    const [isProfileDetailsVisible, setIsProfileDetailsVisible] = useState(false);
    const [isAssigntoVisible, setIsAssigntoVisible] = useState(false);
    const [isAssesmentVisible, setIsAssesmentVisible] = useState(false);
    const { jobDetailId } = useParams();
    const data = useLocation();
    const jobData = data.state?.item;
    const [activeBoardId, setActiveBoardId] = useState(null);
    const [actBoardId, setActBoardId] = useState(null);
    const [activeMappingId, setActiveMappingId] = useState(null);
    const [activeCandidateId, setActiveCandidateId] = useState(null);
    const [activeAssigneeList, setActiveAssigneeList] = useState([]);
    const BASE_URL = process.env.REACT_APP_API_URL
    const [selectedBoard, setSelectedBoard] = useState(0);       
    const [selectedCandidateId, setSelectedCandidateId] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [boardLst, setBoardLst] = useState([]);
    const currentCandidate = useRef(null);
    const [isBoardEditMode, setIsBoardEditMode] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);

    const onDragEnd = (result) => {
        // if(currentCandidate.current.assigneeList.length > 0){
        if(selectedAssigneeList.current.length > 0){
            
            const { source, destination, draggableId } = result;
            if (!destination) return; // If dropped outside any droppable area
            if (source.droppableId === destination.droppableId) {
                // Dragging within the same list
                /*const updatedList = [...tasks[source.droppableId]];
                const [movedItem] = updatedList.splice(source.index, 1);
                updatedList.splice(destination.index, 0, movedItem);
    
                setTasks((prevTasks) => ({
                    ...prevTasks,
                    [source.droppableId]: updatedList,
                }));*/
                const sourceBoard = tasks[source.droppableId];  // Get the full source board data
                const updatedList = [...sourceBoard.candidateList]; // Clone the candidateList
                const [movedItem] = updatedList.splice(source.index, 1); // Remove the dragged item
                updatedList.splice(destination.index, 0, movedItem); // Insert the moved item at the destination index
    
                // Update the state with the new candidateList for the source board
                setTasks((prevTasks) => ({
                    ...prevTasks,
                    [source.droppableId]: {
                        ...sourceBoard,  // Keep the full board data
                        candidateList: updatedList,  // Update only the candidateList
                    },
                }));
            } else {
                // Dragging to a different list
                /*const sourceList = [...tasks[source.droppableId].candidateList];
                const destinationList = [...tasks[destination.droppableId].candidateList];
                const [movedItem] = sourceList.splice(source.index, 1);
                destinationList.splice(destination.index, 0, movedItem);
    
                setTasks((prevTasks) => ({
                    ...prevTasks,
                    [source.droppableId]: sourceList,
                    [destination.droppableId]: destinationList,
                }));
                //console.log(tasks);*/
                const sourceBoard = tasks[source.droppableId]; // Get the source board
                const destinationBoard = tasks[destination.droppableId]; // Get the destination board
    
                const sourceList = [...sourceBoard.candidateList]; // Clone the source board's candidateList
                const destinationList = [...destinationBoard.candidateList]; // Clone the destination board's candidateList
    
                const [movedItem] = sourceList.splice(source.index, 1); // Remove the dragged candidate from source list
                movedItem.boardId = destinationBoard.id; // Update the boardId of the moved candidate
    
                destinationList.splice(destination.index, 0, movedItem); // Insert the candidate in the destination list at the new index
    
                // Update state with both boards' candidate lists and full board data
                setTasks((prevTasks) => ({
                    ...prevTasks,
                    [source.droppableId]: {
                        ...sourceBoard,            // Preserve full board data for source board
                        candidateList: sourceList  // Update the candidateList for source board
                    },
                    [destination.droppableId]: {
                        ...destinationBoard,       // Preserve full board data for destination board
                        candidateList: destinationList // Update the candidateList for destination board
                    }
                }));
    
                updateMapping(draggableId, sourceBoard.id, destinationBoard.id);
                updateJobCount(sourceBoard, destinationBoard);
                updateCandidateActivity(destinationBoard);
                selectedAssigneeList.current = []
            }
        }else{
            toast.error("Please select an assignee", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    const updateCandidateActivity = async (board) => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0];
        const activityDate = `${date} ${time}`;
        const user = JSON.parse(localStorage.getItem("user"));
        let actionOutCome;
        if (board.boardName === "Rejected") {
            actionOutCome = 32; // Rejected from lookup table
        }
        else{
            actionOutCome = 31; // Selected from lookup table
        }
        const requestData = {
            candidateId: currentCandidate.current.candidateId,
            jobId: jobDetailId,
            actionTaken: board.id,
            isBoardActivity: true,
            activityDate: activityDate,
            // actionTakenByList: data.actionTakenBy?.map((user) => user.code), 
            actionTakenByList: [user.id], 
            outcome: actionOutCome,
            remarks: "",
        }; 
        try {
            const response = await candidateApi.createCandidateActivity(requestData);
//   
            if(board.boardName === "Rejected"){
                try{
                    const candidateResponse = await candidateApi.getCandidateById(currentCandidate.current.candidateId);
                    const jobMapRes = await candidateApi.getJobsByCandidate(currentCandidate.current.candidateId);
                    const candidateData = candidateResponse?.data;
                    const jobMapData = jobMapRes?.data;
                    if (candidateData && jobMapData) {
                        const mailBody = getMailBody(candidateData, jobMapData[0].jobTitle, "Rejected");
                        const mailData = {
                                    text: mailBody,
                                    mailAddress: candidateData?.email,
                                    subject: `Update on Your Interview for the ${candidateData.candidateTitle} Position`,
                                  }
                        try{
                            const mailRes = await masterApi.sendNotificationMail(mailData);
                            if(mailRes?.data?.ok){
                                toast.success(mailRes?.data?.message, {
                                    position: "top-right",
                                    autoClose: 2000,
                                })
                                  }
                            }catch (error) {
                                    console.error("Error sending notification mail:", error);
                                    toast.error("Could not send notification mail", {
                                      position: "top-right",
                                      autoClose: 2000,
                                    })
                                  }

                    }
                }catch (error) {
                    console.error("Error fetching candidate details:", error);
                    toast.error("Error fetching candidate details", {
                        position: "top-right",
                        autoClose: 2000,
                    });
                }
                }
        }catch (error) {
        console.error("Error submitting activity:", error);
        toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 2000,
        })
        }
};

    const   updateJobCount = async (sourceBoard, destinationBoard) => {
        let filledPositionChange;
        let updateFilledPositions = false;
        if(destinationBoard.id === 7){
            filledPositionChange = 1;
            updateFilledPositions = true;
        }
        else if(sourceBoard.id === 7){
            filledPositionChange = -1;
            updateFilledPositions = true;
        }
        if(updateFilledPositions){
            try{
                
                const response = await jobApi.updateFilledPositions(jobDetailId,
                                                                    {filledPositions: filledPositionChange});
            }catch (error) {
                console.error("Error updating job positon count:", error);
                toast.error("Error updating job positon count", {
                    position: "top-right",
                    autoClose: 2000,
                });
    
            }
        }
    }

    const showPopup = () => {
        setIsPopupupVisible(true);
    };

    const hidePopup = () => {
        setIsPopupupVisible(false);
        setShowEmployeeForm(false);
    };
    const showCreateBoardPopup = () => {
        setIsCreateBoardVisible(true);
    }
    
    const handleBoardEditButton  = () => {
        setIsCreateBoardVisible(true);
        setIsBoardEditMode(true);
    }

    const hideCreateBoardPopup = () => {
        setActBoardId(null);        
        setIsCreateBoardVisible(false);
        setIsBoardEditMode(false);
    }
    // const showProfileDetailsPopup = () => {
    //     setIsProfileDetailsVisible(true);
    //     setIsCardMoreVisible(!isCardMoreVisible);
    // }
    const showProfileDetailsPopup = (id) => {
        // setIsProfileDetailsVisible(true);
        // setIsCardMoreVisible(!isCardMoreVisible);
        navigate(`/candidate/candidate-details/${id}`, { state: { fromBoards: true, jobId: jobDetailId } });
    }
    const hideProfileDetailsPopup = () => {
        setIsProfileDetailsVisible(false);
    }
    const showAssignPopup = (mappingId,assigneeList) => {
        setActiveMappingId(mappingId);
        // setActiveAssigneeList(assigneeList)
        setIsAssigntoVisible(true);
        //setIsCardMoreVisible(!isCardMoreVisible);
        setActiveCandidateId(null);
    }
    const hideAssignPopup = () => {
        setIsAssigntoVisible(false)
    }
    const showAssesmentPopup = () => {
        setIsAssesmentVisible(true);
        setIsCardMoreVisible(!isCardMoreVisible);

    }
    const hideAssesmentPopup = () => {
        setIsAssesmentVisible(false)
    }


    const openBoardOperationButtons = (boardId) => {
        setActBoardId(actBoardId === boardId ? null : boardId);
    };
    const toggleCardMoreDiv = (candidateId, boardId) => {
        setActiveCandidateId(activeCandidateId === candidateId ? null : candidateId);
        setActiveBoardId(boardId);
    };    
    const updateMapping = async (candidateId, oldBoardId, newBoardId) => {
        const requestData = {
            "jobId": jobDetailId,
            "candidateId": candidateId,
            "oldBoardId": oldBoardId,
            "newBoardId": newBoardId
        }
        let response = await jobApi.updateBoardMapping(requestData);
        if(response?.data?.ok){
            fetchDetails();
        }
    };
    const handleBoardChange = (event) => {
        setSelectedBoard(event.target.value);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && (searchText.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || searchText.trim().length == 0)) {
            fetchDetails();
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value);    
        if (value.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || value.trim().length === 0) {
            fetchDetails(); // or just fetchData(value) if page doesn't matter
        }
    };

    const fetchDetails = async () => {  
        let querystring="";
        setActBoardId(null);
        setActiveBoardId(null);
        setActiveCandidateId(null);
        if(searchText){
            querystring="?searchText=" + searchText
        }
        try{
            let response = await jobApi.getMappingDetailswithBoardDetailsByJobId(jobDetailId,selectedBoard,querystring,rejectedBoardLimitDay);
            setTasks(response?.data); 
            const boards = response?.data;
            if (Array.isArray(boards)) {
            const firstCandidate = boards.find(board => board.candidateList.length > 0)?.candidateList[0];
            if (firstCandidate) {
                setSelectedCandidateId(firstCandidate.candidateId);
            } else {
                setSelectedCandidateId(null); // or handle "no candidate" case
            }
            }
        }catch (error) {
            console.error("Error fetching board mapping details:", error);
            toast.error("Error fetching board mapping details", {
                position: "top-right",
                autoClose: 2000,
            });
        }
        const boardResponse = await masterApi.getActiveBoard();
        if(boardResponse?.data?.ok)  {      
            setBoardLst(boardResponse?.data?.activeboards);
        }
        console.log(boardResponse);                 
    };


    const fetchAddProfileList = async () => {  
        let querystring="";
        
        if(searchText){
            querystring="?searchText=" + searchText
        }
        try{
            let response = await jobApi.getMappingDetailswithBoardDetailsByJobId(jobDetailId,selectedBoard,querystring,rejectedBoardLimitDay);
            setTasks(response.data); 
            const boards = response.data;
            if (Array.isArray(boards)) {
            const firstCandidate = boards.find(board => board.candidateList.length > 0)?.candidateList[0];
            if (firstCandidate) {
                setSelectedCandidateId(firstCandidate.candidateId);
            } else {
                setSelectedCandidateId(null); // or handle "no candidate" case
            }
            }
        }catch (error) {
            console.error("Error fetching board mapping details:", error);
            toast.error("Error fetching board mapping details", {
                position: "top-right",
                autoClose: 2000,
            });
        }
        const boardResponse = await masterApi.getActiveBoard();
        if(boardResponse?.data?.ok)  {      
            setBoardLst(boardResponse?.data?.activeboards);
        }
        console.log(boardResponse);                 
    };


    useEffect(() => {
        fetchDetails();
    }, [jobDetailId,selectedBoard]);


    useEffect(() => { 
        if (rolePermissions) {
            setBoardPerm(getPermissionRights(rolePermissions, FunctionalityNames.BOARD));
            setMappingPerm(getPermissionRights(rolePermissions, FunctionalityNames.MAPPING));
            setCandidateListPerm(getPermissionRights(rolePermissions, FunctionalityNames.CANDIDATE));
        }
    }, [rolePermissions]);

    const handleBoardDelete = async (boardId) => {
        try{
            const response = await jobApi.deleteBoard(boardId);
            if(response?.data?.ok){
                toast.success("Board deleted successfully", {
                    position: "top-right",
                    autoClose: 2000,
                });
                fetchDetails();
            }
        }catch (error) {
            console.error("Error deleting board:", error);
            toast.error("Error deleting board", {
                position: "top-right",
                autoClose: 2000,
            });
        }
    }

    return boardPerm?.view === 1 && (
        <section className="candidates-holder">
            <div className="d-flex align-items-center gap-2 mb-3">
                <h5>Hiring Process</h5>
                <div className="ms-auto">
                    <div className="d-flex gap-3">
                        <select className="form-select w-180" onChange={handleBoardChange}>
                            <option value="0">All</option>
                            {boardLst && boardLst.length > 0 ? (
                                boardLst.map((task) => (
                                    task?.boardName && task?.id ? (
                                        <option key={task.boardName} value={task.id}>
                                            {task.boardName}
                                        </option>
                                    ) : null
                                ))
                            ) : (
                                <option value="">No boards available</option> // Fallback if no boards exist
                            )}
                        </select>
                        <div className="input-group search-container">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={searchText}
                                onChange={handleInputChange} onKeyDown={handleKeyDown}
                            />
                            <button type="button" className="btn plain-btn-secondary">
                                <LuSearch />
                            </button>
                        </div>
                        {mappingPerm?.create === 1 && jobData?.jobStatus === "open" && (
                        <button type="button" className="btn btn-secondary d-flex" onClick={showPopup}>
                            Add Profile
                        </button>
                        )}
                        {mappingPerm?.create === 1 && jobData?.jobStatus === "open" && (
                        <button type="button" className="btn btn-secondary d-flex" onClick={() => setShowEmployeeForm(true)}>
                            Add Employee
                        </button>
                        )}
                        {boardPerm?.create === 1 && (
                        <button type="button" className="btn btn-primary d-flex" onClick={showCreateBoardPopup}>
                            Create Board
                        </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="board-wrapper">
                <DragDropContext onDragEnd={onDragEnd}>
                    <div style={{ display: "flex", gap: "20px", minHeight: "100px"}}>
                        {tasks && Object.entries(tasks).map(([listId, listItems]) => (
                            <Droppable droppableId={listId} key={`droppable-${listId}`}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        style={{ width: "200px" }}
                                    >
                                        <div className="card mb-4 px-4 py-2">
                                            <div className="board-header d-flex align-items-center gap-2 position-relative">
                                                <h6 className="mb-0">
                                                    {tasks[listId].boardName}
                                                </h6>
                                                <div className="ms-auto">
                                                    {(boardPerm?.edit === 1 || boardPerm?.delete === 1) && (
                                                    <button className="plain-btn"
                                                        onClick={() => openBoardOperationButtons(tasks[listId].id)}>
                                                        <MdMoreVert />
                                                    </button>
                                                    )}
                                                </div>
                                                {actBoardId === tasks[listId].id && (
                                                    <section className="moreoption">
                                                        <ul>
                                                        { boardPerm?.edit === 1 && (
                                                            // <li onClick={() => showCreateBoardPopup()}>Edit</li>
                                                            <li onClick={handleBoardEditButton}>Edit</li>
                                                        )}
                                                        { boardPerm?.delete === 1 && !tasks[listId].isDefault && tasks[listId].candidateList.length === 0 && (
                                                            <li 
                                                                // disabled={tasks[listId].isDefault}
                                                                onClick={() => handleBoardDelete(tasks[listId].id)}>Delete</li>
                                                        )}
                                                        </ul>
                                                    </section>
                                                )}

                                            </div>
                                        </div>

                                        {tasks[listId].candidateList?.map((item, index) => (
                                            <Draggable
                                                key={item.candidateId.toString()}
                                                draggableId={item.candidateId.toString()}
                                                index={index}
                                                
                                            >
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            ...provided.draggableProps.style,
                                                        }}
                                                        className="card p-3 mb-4"
                                                        onMouseDown={() => {currentCandidate.current = item;}}
                                                    >
                                                        <div className="d-flex gap-3 align-items-top">
                                                            <div className="dp-holder position-relative d-flex align-items-center position-relative">
                                                                {item.profileImagePath ? (
                                                                    <img
                                                                        src={`${BASE_URL}/${item.profileImagePath}`}
                                                                        alt="Profile"
                                                                    />
                                                                ) : (
                                                                    <span className="default-icon"><TbUser /></span>
                                                                )}
                                                                {item.featured > 0 ?(<span className="featured"><FaStar /></span>) : ""}
                                                                

                                                            </div>
                                                            <div className="right-info">
                                                                <h6 className="mb-1" title={item.firstName + ' ' + item.lastName}>{item.firstName + ' ' + item.lastName}</h6>
                                                                <p className="mb-1" title={item.candidateTitle}>{item.candidateTitle}</p>

                                                                <p className="mb-0 exp-holder">
                                                                    <PiBriefcaseLight />{" "}
                                                                    <span>{item.experienceInYears}Yrs Exp.</span>
                                                                </p>
                                                            </div>
                                                            <div className="ms-auto">
                                                                <button className="plain-btn" onClick={() => toggleCardMoreDiv(item.candidateId, tasks[listId].id)}>
                                                                    <MdMoreVert />
                                                                </button>
                                                                {activeCandidateId === item.candidateId && (
                                                                    <section className="moreoption cardMore">
                                                                        <ul>
                                                                            {/* <li onClick={showProfileDetailsPopup()}>View</li> */}
                                                                            {candidateListPerm?.view === 1 && (
                                                                            <li onClick={() => showProfileDetailsPopup(item.candidateId)}>View</li>
                                                                            )}
                                                                            {mappingPerm?.create === 1 && (
                                                                            <>
                                                                            <li onClick={() => showAssignPopup(item.mappingId,item.assigneeList)}>Assign To</li>
                                                                            <li onClick={showAssesmentPopup}>Assessment</li>
                                                                            </>
                                                                            )}
                                                                        </ul>
                                                                    </section>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div className="d-flex gap-3 align-items-center card-footer">
                                                            {item.assigneeList.map((assignee, index) => (
                                                                <div className="assignedTo position-relative d-flex align-items-center">
                                                                    <img src={`${BASE_URL}/${assignee.profileImagePath}`} alt="ZeaRecruit"  title={assignee.firstName + ' ' + assignee.lastName}  />
                                                                </div>
                                                            ))}

                                                            <div className="ms-auto">
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="date-span previous-round-date">
                                                                        {item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB') : 'N/A'}
                                                                    </span>
                                                                    <span className="arrow">
                                                                        <IoIosArrowRoundForward />
                                                                    </span>
                                                                    <span className="date-span assigned-round-date">
                                                                        {item.updatedAt ? new Date(item.updatedAt).toLocaleDateString('en-GB') : 'N/A'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        ))}
                    </div>
                </DragDropContext>
            </div>
            {isPopupupVisible && <AddProfile closePopup={hidePopup} jobId={jobDetailId} reloadData={fetchDetails}/>}
            {isProfileDetailsVisible && <ProfileDetails closePopup={hideProfileDetailsPopup} />}
            {isAssigntoVisible && <AssignTo closePopup={hideAssignPopup} boardId={activeBoardId} mappingId={activeMappingId} 
                                        assigneeList={activeAssigneeList} reloadData={fetchDetails}/>}
            {isAssesmentVisible && <AddAssesment closePopup={hideAssesmentPopup} jobId={jobDetailId} candidateId={selectedCandidateId}/>}
            {isCreateBoardVisible && <CreateBoard closePopup={hideCreateBoardPopup} reloadData={fetchDetails} boardId={actBoardId}
                                                boardList={boardLst} isEditMode={isBoardEditMode}/>}
            {showEmployeeForm && <EmployeeCandidateForm closePopup={hidePopup}/>}

        </section>
    );
}
